import { memo } from 'react'
import { Stack, Text } from '@chakra-ui/react'

import { PhotographicCamera } from 'components/icons'
import { useUploadImage } from 'components/uploads/UploadImage/context/Provider'

function UploadWhenTakingPhoto() {
  const { size, setView } = useUploadImage()

  return (
    <Stack
      onClick={() => setView('Webcan')}
      tabIndex={0}
      bg="light"
      className="accessible"
      p={2}
      width={size}
      height={size}
      align="center"
      justify="center"
      _hover={{ bg: 'lighterPrimary', color: 'primary' }}
    >
      <Stack align="center">
        <PhotographicCamera />
        <Text>Tirar foto</Text>
      </Stack>
    </Stack>
  )
}

export default memo(UploadWhenTakingPhoto)
